export default "__VITE_ASSET__rTTgwzAU__"